import { motion } from "framer-motion";
import { Truck, Lock, Layers } from "lucide-react";

const FEATURES = [
    {
        icon: Truck,
        title: "Livraison offerte dès 50 €",
        text: "Gratuite dès 50 € d'achat, 2,99 € en dessous. Préparée avec soin et suivie par e-mail.",
    },
    {
        icon: Lock,
        title: "Paiement sécurisé",
        text: "Carte bancaire ou PayPal — chiffré de bout en bout.",
    },
    {
        icon: Layers,
        title: "Croslite™ anti-microbien",
        text: "Ultra-légères, amortissantes, anti-odeurs. Confort toute la journée.",
    },
];

export default function Features() {
    return (
        <section id="features" className="py-24 sm:py-28 bg-spidey-panel/40 border-y border-zinc-900">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-14"
                >
                    <p className="text-xs font-mono-brand uppercase tracking-[0.3em] text-spidey-neon">
                        Les atouts
                    </p>
                    <h2 className="mt-3 font-display uppercase text-3xl sm:text-4xl text-white tracking-tight">
                        Pas juste des clogs.
                    </h2>
                </motion.div>

                <div className="grid sm:grid-cols-3 gap-5">
                    {FEATURES.map((f, i) => (
                        <motion.div
                            key={f.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                            className="group h-full bg-spidey-card border border-zinc-800/80 rounded-2xl p-7 transition-all duration-300 hover:border-spidey-red/60 hover:-translate-y-1.5"
                        >
                            <span className="font-mono-brand text-xs text-zinc-600">
                                0{i + 1}
                            </span>
                            <f.icon
                                size={30}
                                className="mt-4 text-spidey-red transition-transform duration-300 group-hover:scale-110"
                            />
                            <h3 className="mt-5 text-lg font-bold text-white leading-snug">
                                {f.title}
                            </h3>
                            <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{f.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
